<template>
  <section class="popMain full">
    <div class="grid">
      <div class="grid1">
        <span class="title">優惠門檻</span>
        <table class="content fit empty">
          <tr>
            <td>
              <label class="check">
                <input
                  type="radio"
                  v-model="editPromotion.usageRestrctions.restrictionType"
                  value="amount"
                  :checked="
                    editPromotion.usageRestrctions.restrictionType === 'amount'
                  "
                  :disabled="disabled"
                />
                <!-- checked="checked" -->
                <span class="checkmark radio"></span>
                <div class="text">金額滿</div>
              </label>
            </td>
            <td>
              <div class="number">
                <input
                  type="number"
                  v-model="editPromotion.usageRestrctions.amount"
                  :min="0"
                  :disabled="disabled"
                />
                <span class="content unit">元</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <label class="check">
                <input
                  type="radio"
                  v-model="editPromotion.usageRestrctions.restrictionType"
                  value="qty"
                  :checked="
                    editPromotion.usageRestrctions.restrictionType === 'qty'
                  "
                  :disabled="disabled"
                />
                <!-- checked="checked" -->
                <span class="checkmark radio"></span>
                <div class="text">數量滿</div>
              </label>
            </td>
            <td>
              <div class="number">
                <input
                  type="number"
                  v-model="editPromotion.usageRestrctions.qty"
                  :min="0"
                  :disabled="disabled"
                />
                <span class="content unit">個</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <label class="check">
                <input
                  type="radio"
                  v-model="editPromotion.usageRestrctions.restrictionType"
                  value="perItems"
                  :checked="
                    editPromotion.usageRestrctions.restrictionType ===
                      'perItems'
                  "
                  :disabled="disabled"
                />
                <!-- checked="checked" -->
                <span class="checkmark radio"></span>
                <div class="text">數量每滿</div>
              </label>
            </td>
            <td>
              <div class="number">
                <input
                  type="number"
                  v-model="editPromotion.usageRestrctions.perItems"
                  :min="0"
                  :disabled="disabled"
                />
                <span class="content unit">個</span>
              </div>
            </td>
            <td>
              <span class="remark">可累計<br>（買6折1，此處設6)</span>
            </td>
          </tr>
          <tr>
            <td>
              <label class="check">
                <input
                  type="radio"
                  v-model="editPromotion.usageRestrctions.restrictionType"
                  value="carts"
                  :checked="!editPromotion.usageRestrctions.restrictionType"
                  :disabled="disabled"
                />
                <!-- checked="checked" -->
                <span class="checkmark radio"></span>
                <div class="text">加購促銷</div>
              </label>
            </td>
            <td colspan="2">
              <span class="remark">（POS串接用；同價位第二件折N元）</span>
            </td>
          </tr>
          <tr>
            <td>
              <label class="check">
                <input
                  type="radio"
                  v-model="editPromotion.usageRestrctions.restrictionType"
                  value="none"
                  :checked="!editPromotion.usageRestrctions.restrictionType"
                  :disabled="disabled"
                />
                <!-- checked="checked" -->
                <span class="checkmark radio"></span>
                <div class="text">不限</div>
              </label>
            </td>
          </tr>
        </table>
      </div>
      <div class="grid2">
        <span class="title">會員門檻</span>
        <label class="check">
          <input
            type="radio"
            v-model="editPromotion.roleRestrictions.userType"
            value="new"
            :checked="editPromotion.roleRestrictions.userType === 'new'"
            :disabled="disabled"
          />
          <!-- checked="checked" -->
          <span class="checkmark radio"></span>
          <div class="text">新戶 (首次下單)</div>
        </label>
        <!-- <label class="check">
          <input
            type="radio"
            v-model="editPromotion.roleRestrictions.userType"
            value="old"
            :checked="editPromotion.roleRestrictions.userType === 'old'"
            :disabled="disabled"
          />
          <span class="checkmark radio"></span>
          <div class="text">舊戶 (已下過單)</div>
        </label> -->
        <label class="check">
          <input
            type="radio"
            v-model="editPromotion.roleRestrictions.userType"
            value="none"
            :checked="editPromotion.roleRestrictions.userType === 'none'"
            :disabled="disabled"
          />
          <!-- checked="checked" -->
          <span class="checkmark radio"></span>
          <div class="text">不限</div>
        </label>
      </div>
      <!-- <div class="grid3">
        <span class="title"> 優惠人數</span>
        <div class="flexH">
          <label class="check">
            <input
              type="radio"
              v-model="editPromotion.general.totalUsageType"
              value="limited"
              :checked="editPromotion.general.totalUsageType === 'limited'"
              :disabled="disabled"
            />
            <span class="checkmark radio"></span>
          </label>
          <div class="number">
            <input
              type="number"
              v-model="editPromotion.general.totalUsage"
              :min="1"
              :disabled="disabled"
            />
            <span class="content unit">人</span>
          </div>
        </div>
        <label class="check">
          <input
            type="radio"
            v-model="editPromotion.general.totalUsageType"
            value="none"
            :checked="editPromotion.general.totalUsageType !== 'limit'"
            :disabled="disabled"
          />
          <span class="checkmark radio"></span>
          <div class="text">不限</div>
        </label>
      </div> -->
      <div class="grid4" v-show="editPromotion.usageRestrctions.restrictionType !== 'carts'">
        <span class="title">優惠方式</span>
        <table class="content fit empty">
          <tr>
            <td>
              <label class="check">
                <input
                  type="radio"
                  v-model="editPromotion.general.discountType"
                  value="fixed"
                  :checked="editPromotion.general.discountType === 'fixed'"
                  :disabled="disabled"
                />
                <!-- checked="checked" -->
                <span class="checkmark radio"></span>
                <div class="text">折價</div>
              </label>
            </td>
            <td>
              <div class="number">
                <input
                  type="number"
                  v-model="editPromotion.general.fixed"
                  :min="1"
                  :disabled="disabled"
                />
                <span class="content unit">元</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <label class="check">
                <input
                  type="radio"
                  v-model="editPromotion.general.discountType"
                  value="percentage"
                  :checked="editPromotion.general.discountType === 'percentage'"
                  :disabled="disabled"
                />
                <!-- checked="checked" -->
                <span class="checkmark radio"></span>
                <div class="text">折扣</div>
              </label>
            </td>
            <td>
              <div class="number">
                <input
                  type="number"
                  v-model="editPromotion.general.percentage"
                  :min="1"
                  :max="100"
                  :disabled="disabled"
                />
                <span class="content unit">%</span>
              </div>
            </td>
            
            <td>
              <span class="remark">例如：$50折10%<br />$50九折，即$45</span>
            </td>
          </tr>
          <!-- <tr>
            <td>
              <label class="check">
                <input
                  type="radio"
                  v-model="editPromotion.general.discountType"
                  value="discountPerItemsLow"
                  :checked="
                    editPromotion.general.discountType === 'discountPerItemsLow'
                  "
                  :disabled="disabled"
                />
                <span class="checkmark radio" style="top: 14px;"></span>
                <div class="text">折價<br />商品最低價</div>
              </label>
            </td>
            <td>
              <div class="number">
                <input
                  type="number"
                  v-model="editPromotion.general.discountPerItemsLow"
                  :min="1"
                  :disabled="disabled"
                />
                <span class="content unit">個</span>
              </div>
            </td>
            <td colspan="2">
              <span class="remark"
                >例如：買5送1，買5杯$50 + 1杯$40<br />即折$40</span
              >
            </td>
          </tr> -->
          <tr>
            <td>
              <label class="check">
                <input type="radio"
                  v-model="editPromotion.general.discountType"
                  value="discountPerItemsAvg"
                  :checked="
                    editPromotion.general.discountType === 'discountPerItemsAvg'
                  "
                  :disabled="disabled" />
                <!-- checked="checked" -->
                <span class="checkmark radio" style="top: 14px;"></span>
                <div class="text">折價<br />商品均價</div>
              </label>
            </td>
            <td>
              <div class="number">
                <input 
                  type="number"
                  v-model="editPromotion.general.discountPerItemsAvg"
                  :min="1"
                  :disabled="disabled" />
                <span class="content unit">個</span>
              </div>
            </td>
            <td colspan="2">
              <span class="remark"
                >例如：買5送1，買5杯$50 + 1杯$40<br />(250+40)/6 =
                48.33，即折$48</span
              >
            </td>
          </tr>
          <tr>
            <td>
              <label class="check">
                <input
                  type="radio"
                  v-model="editPromotion.general.discountType"
                  value="discountPerItems5"
                  :checked="
                    editPromotion.general.discountType === 'discountPerItems5'
                  "
                  :disabled="disabled"
                />
                <!-- checked="checked" -->
                <span class="checkmark radio" style="top: 14px;"></span>
                <div class="text">折價<br />商品均價後，折5的倍數低價</div>
              </label>
            </td>
            <td>
              <div class="number">
                <input
                  type="number"
                  v-model="editPromotion.general.discountPerItems5"
                  :min="1"
                  :disabled="disabled"
                />
                <span class="content unit">個</span>
              </div>
            </td>
            <td colspan="2">
              <span class="remark"
                >例如：買5送1，買5杯$50 + 1杯$40<br />(250+40)/6 =
                48.33，即折$45</span
              >
            </td>
          </tr>
          <!-- <tr>
            <td>折扣後小數點處理方式</td>
            <td>
              <div class="dropdown">
                <select
                  name="type"
                  v-model="editPromotion.general.carryMethod"
                  
                >
                  <option value="round">四捨五入</option>
                  <option value="floor">無條件捨去</option>
                  <option value="ceil">無條件進位</option>
                </select>
                <div class="arrow">
                  <FontAwesomeIcon icon="caret-down" />
                </div>
              </div>
            </td>
          </tr> -->
        </table>
      </div>
      <div class="grid-carts" v-show="editPromotion.usageRestrctions.restrictionType === 'carts'">
        <span class="title">
          指定加購、分類或商品與折價金額
          <a class="add-cart" @click="addCartPromotion">
            <FontAwesomeIcon icon="plus"/>
          </a>
        </span>
        <table class="content fit empty">
          <section v-for="(item, index) in editPromotion.usageRestrctions.carts" :key="index">
            <tr>
              <td width="70%"> 
                請輸入指定加購代碼，以「,」分隔
              </td>
              <td colspan="2">
                <span class="remark">目前只支援固定金額折價</span>
              </td>
            </tr>
            <tr>           
              <td width="70%">
                <div class="text">
                  <input
                    type="text"
                    size="80%"
                    class="input"
                    v-model="item.carts"
                    :min="0"
                    :disabled="disabled"
                  />
                </div>
              </td>
              <td width="20%">
                
                <div class="number">
                  <input
                    type="number"
                    v-model="item.amount"
                    :min="1"
                    :disabled="disabled"
                  />
                  <span class="content unit">元</span>
                </div>
              </td>
              <td width="10%">
                <a @click="removeCartPromotion">
                  <FontAwesomeIcon icon="trash"/>
                </a>
              </td>
            </tr>
          </section>
       
          <!-- <tr>
            <td>
              <label class="check">
                <input
                  type="radio"
                  v-model="editPromotion.general.cartType"
                  value="none"
                  :checked="editPromotion.general.cartType === 'none'"
                  :disabled="disabled"
                />
                <span class="checkmark radio"></span>
                <div class="text">不限</div>
              </label>
            </td>
            <td colspan="2">
              <span class="remark">不限分類或商品，全部納入折扣計算</span>
            </td>
          </tr> -->
        
        </table>
      </div>
    </div>
    <!-- <div class="areaH">
      <div class="areaV">
        <div class="box">
          <span class="title">優惠門檻</span>
          <div class="item">
            <label class="check">
              <input
                type="radio"
                name="usageRestriction"
                v-model="editPromotion.usageRestrctions.restrictionType"
                value="amount"
                :checked="
                  editPromotion.usageRestrctions.restrictionType === 'amount'
                "
                :disabled="disabled"
              />
              <span class="checkmark radio"></span>
              <div class="text" style="min-width: 48px;">金額滿</div>
            </label>
            <div class="number" style="width: 90px; margin-left: 10px;">
              <input
                type="number"
                v-model="editPromotion.usageRestrctions.amount"
                :min="0"
                :disabled="disabled"
              />
              <span class="content unit">元</span>
            </div>
          </div>
          <div class="item">
            <label class="check">
              <input
                type="radio"
                name="usageRestriction"
                v-model="editPromotion.usageRestrctions.restrictionType"
                value="qty"
                :checked="
                  editPromotion.usageRestrctions.restrictionType === 'qty'
                "
                :disabled="disabled"
              />
              <span class="checkmark radio"></span>
              <div class="text" style="min-width: 48px;">數量滿</div>
            </label>
            <div class="number" style="width: 90px; margin-left: 10px;">
              <input
                type="number"
                v-model="editPromotion.usageRestrctions.qty"
                :min="0"
                :disabled="disabled"
              />
              <span class="content unit">個</span>
            </div>
          </div>
          <div class="item">
            <label class="check">
              <input
                type="radio"
                name="usageRestriction"
                v-model="editPromotion.usageRestrctions.restrictionType"
                value="perItems"
                :checked="
                  editPromotion.usageRestrctions.restrictionType === 'perItems'
                "
                :disabled="disabled"
              />
              <span class="checkmark radio"></span>
              <div class="text">數量每滿</div>
            </label>
            <div class="number" style="width: 90px; margin-left: 10px;">
              <input
                type="number"
                v-model="editPromotion.usageRestrctions.perItems"
                :min="0"
                :disabled="disabled"
              />
              <span class="content unit">個</span>
            </div>
            <span class="remark" style="margin-left: 10px;">可累計</span>
          </div>
          <div class="item" style="height: 40px;">
            <label class="check">
              <input
                type="radio"
                name="usageRestriction"
                v-model="editPromotion.usageRestrctions.restrictionType"
                value="none"
                :checked="!editPromotion.usageRestrctions.restrictionType"
                :disabled="disabled"
              />
              <span class="checkmark radio"></span>
              <div class="text">不限</div>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="areaH">
      <div class="areaV">
        <div class="box">
          <span class="title">優惠人數</span>
          <div class="item">
            <label class="check">
              <input
                type="radio"
                v-model="editPromotion.general.totalUsageType"
                value="limited"
                :checked="editPromotion.general.totalUsageType === 'limited'"
                :disabled="disabled"
              />
              <span class="checkmark radio"></span>
            </label>
            <div class="number" style="width: 90px;">
              <input
                type="number"
                v-model="editPromotion.general.totalUsage"
                :min="1"
                :disabled="disabled"
              />
              <span class="content unit">人</span>
            </div>
          </div>
          <div class="item" style="height: 40px;">
            <label class="check">
              <input
                type="radio"
                v-model="editPromotion.general.totalUsageType"
                value="none"
                :checked="editPromotion.general.totalUsageType !== 'limit'"
                :disabled="disabled"
              />
              <span class="checkmark radio"></span>
              <div class="text">不限</div>
            </label>
          </div>
        </div>
      </div>
      <div class="areaV">
        <div class="box">
          <span class="title">會員門檻</span>
          <div class="item">
            <label class="check">
              <input
                type="radio"
                v-model="editPromotion.roleRestrictions.userType"
                value="new"
                :checked="editPromotion.roleRestrictions.userType === 'new'"
                :disabled="disabled"
              />
              <span class="checkmark radio"></span>
              <div class="text">新戶 (首次下單)</div>
            </label>
          </div>
          <div class="item">
            <label class="check">
              <input
                type="radio"
                v-model="editPromotion.roleRestrictions.userType"
                value="old"
                :checked="editPromotion.roleRestrictions.userType === 'old'"
                :disabled="disabled"
              />
              <span class="checkmark radio"></span>
              <div class="text">舊戶 (已下過單)</div>
            </label>
          </div>
          <div class="item">
            <label class="check">
              <input
                type="radio"
                v-model="editPromotion.roleRestrictions.userType"
                value="none"
                :checked="editPromotion.roleRestrictions.userType === 'none'"
                :disabled="disabled"
              />
              <span class="checkmark radio"></span>
              <div class="text">不限</div>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="areaH">
      <div class="areaV">
        <div class="box">
          <span class="title">優惠方式</span>
          <div class="item" style="height: 44px;">
            <label class="check">
              <input
                type="radio"
                v-model="editPromotion.general.discountType"
                value="fixed"
                :checked="editPromotion.general.discountType === 'fixed'"
                :disabled="disabled"
              />
              <span class="checkmark radio"></span>
              <div class="text" style="min-width: 151px;">折價</div>
            </label>
            <div class="number" style="width: 90px; margin-left: 10px;">
              <input
                type="number"
                v-model="editPromotion.general.fixed"
                :min="1"
                :disabled="disabled"
              />
              <span class="content unit">元</span>
            </div>
          </div>
          <div class="item" style="height: 44px;">
            <label class="check">
              <input
                type="radio"
                v-model="editPromotion.general.discountType"
                value="percentage"
                :checked="editPromotion.general.discountType === 'percentage'"
                :disabled="disabled"
              />
              <span class="checkmark radio"></span>
              <div class="text" style="min-width: 151px;">折扣</div>
            </label>
            <div class="number" style="width: 90px; margin-left: 10px;">
              <input
                type="number"
                v-model="editPromotion.general.percentage"
                :min="1"
                :max="100"
                :disabled="disabled"
              />
              <span class="content unit">%</span>
            </div>
            <div class="dropdown" style="margin-left: 10px;">
              <select
                name="type"
                v-model="editPromotion.general.carryMethod"
                :disabled="disabled"
              >
                <option value="round">四捨五入</option>
                <option value="floor">無條件捨去</option>
                <option value="ceil">無條件進位</option>
              </select>
              <div class="arrow">
                <FontAwesomeIcon icon="caret-down" />
              </div>
            </div>
            <span class="remark" style="margin-left: 10px;"
              >例如：$50折10%<br />$50九折，即$45</span
            >
          </div>
          <div class="item">
            <label class="check">
              <input
                type="radio"
                v-model="editPromotion.general.discountType"
                value="discountPerItemsLow"
                :checked="
                  editPromotion.general.discountType === 'discountPerItemsLow'
                "
                :disabled="disabled"
              />
              <span class="checkmark radio" style="top: 14px;"></span>
              <div class="text" style="min-width: 151px;">
                折價<br />商品最低價
              </div>
            </label>
            <div class="number" style="width: 90px; margin-left: 10px;">
              <input
                type="number"
                v-model="editPromotion.general.discountPerItemsLow"
                :min="1"
                :disabled="disabled"
              />
              <span class="content unit">個</span>
            </div>
            <span class="remark" style="margin-left: 10px;"
              >例如：買5送1，買5杯$50 + 1杯$40<br />即折$40</span
            >
          </div>
          <div class="item">
            <label class="check">
              <input
                type="radio"
                v-model="editPromotion.general.discountType"
                value="discountPerItemsAvg"
                :checked="
                  editPromotion.general.discountType === 'discountPerItemsAvg'
                "
                :disabled="disabled"
              />
              <span class="checkmark radio" style="top: 14px;"></span>
              <div class="text" style="min-width: 151px;">
                折價<br />商品均價
              </div>
            </label>
            <div class="number" style="width: 90px; margin-left: 10px;">
              <input
                type="number"
                v-model="editPromotion.general.discountPerItemsAvg"
                :min="1"
                :disabled="disabled"
              />
              <span class="content unit">個</span>
            </div>
            <span class="remark" style="margin-left: 10px;"
              >例如：買5送1，買5杯$50 + 1杯$40<br />(250+40)/6 =
              48.33，即折$48</span
            >
          </div>
          <div class="item">
            <label class="check">
              <input
                type="radio"
                v-model="editPromotion.general.discountType"
                value="discountPerItems5"
                :checked="
                  editPromotion.general.discountType === 'discountPerItems5'
                "
                :disabled="disabled"
              />
              <span class="checkmark radio" style="top: 14px;"></span>
              <div class="text">折價<br />商品均價後，折5的倍數低價</div>
            </label>
            <div class="number" style="width: 90px; margin-left: 10px;">
              <input
                type="number"
                v-model="editPromotion.general.discountPerItems5"
                :min="1"
                :disabled="disabled"
              />
              <span class="content unit">個</span>
            </div>
            <span class="remark" style="margin-left: 10px;"
              >例如：買5送1，買5杯$50 + 1杯$40<br />(250+40)/6 =
              48.33，即折$45</span
            >
          </div>
        </div>
      </div>
    </div> -->
  </section>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  components: {
    FontAwesomeIcon
  },
  props: {
    editPromotion: Object,
    disabled: Boolean,
    value: String
  },
  data() {
    return {};
  },
  computed: {},
  created: function() {},
  mounted() {},
  methods: {
    addCartPromotion() {
      console.log('addCartsPromotion');
      this.$emit('add-cart', this.editPromotion)
    },
    removeCartPromotion(index) {
      console.log('removeCartsPromotion');
      this.$emit('remove-cart', {
        editPromotion: this.editPromotion,
        removeCartIndex: index
      })
    }
  }
  
};
</script>
<style scoped src="../../../../../src/assets/css/shop-console.css"></style>
<style scoped>
.add-cart {
  width: 20px !important;
  height: 20px !important;
  margin: 0 10px;
  border-radius: 99px;
  align-items: center;
  justify-content: center;
  color: white;
  background-color: #F96332;
  .svg-inline--fa {
    width: 20px;
  }
}

</style>